export function isServiceTypeModuleActive(modules) {
  if (!Array.isArray(modules)) {
    return false
  }
  const module = modules.find(item => {
    const keyword = String(item.permission_keyword || '').toLowerCase()
    const name = String(item.name || '').toLowerCase()
    return keyword === 'service-type' || name.includes('service type rate card')
  })
  if (!module) {
    return false
  }
  return module.is_active === true
    || module.is_active === 1
    || module.is_active === '1'
    || module.is_active === 'true'
}

export function isServiceTypeRateCardFeatureEnabled(modules, orderSetting) {
  const settingOn = !!(orderSetting && (orderSetting.service_type_rate_card === true
    || orderSetting.service_type_rate_card === 1
    || orderSetting.service_type_rate_card === '1'))
  return isServiceTypeModuleActive(modules) && settingOn
}

export function isServiceTypeFeatureOn(orderSetting) {
  let modules = []
  try {
    modules = JSON.parse(localStorage.getItem('module_data') || '[]')
  } catch (e) {
    modules = []
  }
  return isServiceTypeRateCardFeatureEnabled(modules, orderSetting)
}

export function serviceTypeChargeMessage(serviceTypeId, options) {
  if (!serviceTypeId) {
    return ''
  }
  const selected = (options || []).find(item => String(item.id) === String(serviceTypeId))
  if (!selected || !selected.name) {
    return ''
  }
  return `You have selected ${selected.name}. You will be charged for ${selected.name} Service.`
}

export function appliedServiceTypeLabel(applied) {
  if (!applied || applied === 'Default') {
    return 'Default'
  }
  return applied.name || 'Default'
}
